import { Avatar } from 'antd';
import { AxiosRequestConfig } from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { onStartDownloadImage } from '../../appRedux/actions';
import { IFetchUserImage } from '../../interfaces';

function FetchUserImage(props: IFetchUserImage) {
  const [objectUrl, setObjectUrl] = useState<null | string>('');
  const [err, setErr] = useState(false);

  useEffect(() => {
    async function getImage(url: string) {
      const http = await FaraGostarDynamicHttp();

      try {
        const config: AxiosRequestConfig = {
          responseType: 'blob',
        };

        const result = await http.get(url, config);
        const objUrl = URL.createObjectURL(result.data);

        setObjectUrl(objUrl);
      } catch (err) {
        setErr(true);
      }
    }
    getImage(props.src);

    return () => {
      setObjectUrl(null);
    };
  }, [props.src]);

  useEffect(() => {
    if (objectUrl) return URL.revokeObjectURL(objectUrl);
  }, [objectUrl]);

  if (err) {
    return (
      <div className={`gx-modal-box-avatar gx-mx-2 ${props.className}`}>
        <Avatar
          size="large"
          src={require('../../assets/images/placeholder.jpg')}
        />
      </div>
    );
  }
  return (
    <div className="gx-d-flex gx-flex-row gx-justify-content-between gx-align-items-center">
      <div
        className={`gx-d-flex gx-flex-row ${
          props.fullWidth ? 'gx-w-100' : 'gx-w-25'
        }`}
      >
        {objectUrl ? (
          <img
            alt={props.alt ? props.alt : 'fetch-image'}
            className={props.className}
            src={objectUrl}
          />
        ) : (
          <Fragment>
            {props.defaultImage ? (
              <img
                alt={props.alt ? props.alt : 'fetch-image'}
                className={props.className}
                src={props.defaultImage}
              />
            ) : (
              <div
                className={`gx-modal-box-avatar gx-mx-2 ${props.className} ${
                  props.fullWidth ? 'gx-size-90' : ''
                }`}
              >
                <Avatar
                  size="large"
                  src={require('../../assets/images/placeholder.jpg')}
                />
              </div>
            )}
          </Fragment>
        )}
      </div>

      <div className="gx-d-flex gx-flex-row gx-justify-content-start gx-w-75 gx-fs-sm">
        {props.text && <span>{props.text}</span>}
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => ({
  onStartDownloadImage: (imageSrc: string) =>
    dispatch(onStartDownloadImage(imageSrc)),
});

export default connect(null, mapDispatchToProps)(FetchUserImage);
